/**
 * 塾API
 * このAPIはadmin権限でのみ呼び出すため権限パラメータ不要
 */
import { Component, Vue } from 'vue-property-decorator'
import { ApiResponseAcademy, ApiResponseAcademyList, ApiResponseAcademyEditData } from '@/models/apiResponses/academies'
import { AcademySearchParamsType, AcademyEditType } from '@/models/academyListModel'

@Component
export default class AcademiesApi extends Vue {
  /**
   * 塾一覧取得
   * @returns 塾一覧情報
   */
  protected async getAcademies(): Promise<ApiResponseAcademy[]> {
    const { data }: { data: ApiResponseAcademy[] } = await Vue.prototype.$http.httpWithToken
      .get('/v2/admin/academies')
      .catch(() => ({ data: [] }))

    return data
  }

  /**
   * 塾一覧検索
   * @param params 検索パラメーター群
   * @returns ページネーション情報付き塾一覧情報
   */
  protected async searchAcademies(params: AcademySearchParamsType): Promise<ApiResponseAcademyList> {
    const { data }: { data: ApiResponseAcademyList } = await Vue.prototype.$http.httpWithToken
      .get(`/v2/admin/academies/search`, { params: params })
      .catch(() => ({ data: { responses: [], pagination: null } }))

    return data
  }

  /**
   * 塾情報取得
   * @param id 塾ID
   * @returns 塾情報
   */
  protected async getAcademyData(id: number): Promise<ApiResponseAcademyEditData> {
    const { data }: { data: ApiResponseAcademyEditData } = await Vue.prototype.$http.httpWithToken.get(
      `/v2/admin/academies/${id}`
    )

    return data
  }

  /**
   * 塾情報登録
   * @param editData 塾編集情報
   */
  protected async createAcademyData(editData: AcademyEditType): Promise<void> {
    await Vue.prototype.$http.httpWithToken.post(`/v2/admin/academies`, {
      academyName: editData.academyName,
      academyCode: editData.academyCode,
    })
  }

  /**
   * 塾情報更新
   * @param editData 塾更新情報
   */
  protected async updateAcademyData(editData: AcademyEditType): Promise<void> {
    await Vue.prototype.$http.httpWithToken.put(`/v2/admin/academies/${editData.id}`, {
      academyName: editData.academyName,
    })
  }

  /**
   * 塾情報削除
   * @param id 塾ID
   */
  protected async deleteAcademyData(id: number): Promise<void> {
    await Vue.prototype.$http.httpWithToken.delete(`/v2/admin/academies/${id}`)
  }

  /**
   * 塾一覧のエクセルダウンロード
   * @param params 検索パラメーター群
   * @param academyIds ダウンロード対象の塾ID
   * @returns エクセルデータ
   */
  protected async exportAcademyExcel(params: AcademySearchParamsType, academyIds: number[]): Promise<Blob> {
    const { data }: { data: Blob } = await Vue.prototype.$http.httpWithToken.get('/v2/admin/academies/export', {
      params: Object.assign(params, { academyIds: academyIds }),
      responseType: 'blob',
      dataType: 'binary',
    })

    return data
  }

  /**
   * 塾一覧エクセルアップロード
   * @param file エクセルファイル
   */
  protected async importAcademyExcel(file: File): Promise<void> {
    const headers = { 'Content-Type': 'multipart/form-data' }
    const params = new FormData()
    params.append('excel', file)
    await Vue.prototype.$http.httpWithToken.post('v2/admin/academies/import', params, {
      headers: headers,
    })
  }
}
